export const decodeHtml = (html) => {
  if (typeof window === 'undefined') return html
  
  // Client-side implementation
  const textarea = document.createElement('textarea')
  textarea.innerHTML = html
  return textarea.value
}